export const SET_RELOAD_ALL_REVIEWS = '';

export interface SetReloadAllReviews {
  type: typeof SET_RELOAD_ALL_REVIEWS;
  payload: boolean;
}

export type ReviewAction = SetReloadAllReviews;
